import React, { useState, useEffect }  from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import COETemplate from "./components/COETemplate";
import { getEmployeeCOEDetails } from "../../../redux/employee/employeeState";


const PreviewCOE = ({getEmployeeCOE}) => {
	const { empId } = useParams();
	
	useEffect(() => {
	    getEmployeeCOE(empId);
    }, [empId]);
	
	return (
    	<div>	    
	    	<COETemplate />
	      	
	    </div>
    );
};

const mapStateToProps = (state) => ({
	
});

const mapDispatchToProps = (dispatch) => ({
	getEmployeeCOE: (id) => dispatch(getEmployeeCOEDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewCOE);